import apiFetch from '../apiFetch'

export default function (token, financingId, page, pageSize, orderBy) {
  return apiFetch({ endPoint: 'FinanceCompany/FindCompaniesWithUo/' + financingId + '/' + page + '/' + pageSize + '?orderBy=' + orderBy, method: 'GET', token: token })
}
